import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useDesignVersionPath } from '@/hooks'

import { getAssetLink } from '../../../helpers/get-asset-link'
import Icon from '../../Icons'
import { selectItem } from '../../../reducers/filtersReducer'

const TrainerClients = ({ trainerData, selectItem }) => {
  const { t } = useTranslation(['organisation'])
  const navigate = useNavigate()

  const clientsPath = useDesignVersionPath('clients', {
    legacy: '/dashboard/clients/legacy',
    new: '/dashboard/clients',
  })

  const goToClientsList = (e, trainer) => {
    e.preventDefault()
    const newTrainer = {
      id: trainer.id,
      avatar: trainer.user.avatar,
      text: `${trainer.user.firstName} ${trainer.user.lastName}`,
    }
    selectItem(
      'managerClients',
      t('organisation:staff.trainerClients.staffMemberFilterLabel'),
      newTrainer,
      false,
    )

    // ✅ Navigate using React Router 6
    navigate(clientsPath)
  }

  return (
    <div className="ctp-staff-trainer__clients">
      <strong>{t('organisation:staff.trainerClients.title')}</strong>
      <ul>
        {trainerData.clients.slice(0, 4).map((client) => (
          <li key={client.id}>
            <img
              src={getAssetLink({ path: 'chitown-avatar/avatar', file: client.user.avatar })}
              alt={t('organisation:staff.trainerClients.clientAvatarAlt')}
            />
          </li>
        ))}
      </ul>
      <div className="field">
        <div className="control">
          <span className="input" onClick={(e) => goToClientsList(e, trainerData)}>
            {t('organisation:staff.trainerClients.allCount', { count: trainerData.clients.length })}
            <span>
              <Icon icon="forward" />
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

TrainerClients.propTypes = {
  trainerData: PropTypes.object.isRequired,
  selectItem: PropTypes.func.isRequired,
}

export default connect(null, { selectItem })(TrainerClients)
